module.exports = __webpack_public_path__ + "static/media/banner-photo360.fd67d260.webp";